import React from "react";
import { Center, Container, Loader } from "@mantine/core";

const ProgressIndicator: React.FC = () => (
  <Container style={{ marginTop: "20%" }}>
    <Center>
      <Loader color="jem-theme" size="xl" />
    </Center>
  </Container>
);

export default ProgressIndicator;
